import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { RoleEnum } from '../models';
import { PermissionAccessService } from '../services/permission-access.service';
import { AppState } from '../../store/app.state';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard {
  private readonly store = inject(Store);
  user$ = this.store.select(AppState.currentUser);
  user: any;

  constructor(private permissionService: PermissionAccessService) {
    this.user$?.subscribe(user => {
      this.user = user;
    });
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.user?.roles?.[0]?.title === RoleEnum.SuperAdmin || this.user?.roles?.[0]?.title === RoleEnum.Employee) {
      return true;
    } else {
      return this.permissionService.hasPermissionGroup(route?.data?.permission);
    }
  }
}
